export default __webpack_public_path__ + "icon_battery_with_plug.cc4f95f8656cc29df9844a3ca36d5882.svg";